import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const chartLegendStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.md}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};

  > span {
    display: inline-flex;
    align-items: center;
    gap: ${theme.space.xs}px;
  }
`;

/* 12px 고정 견본. */
export const swatchStyle = (color: string, outline?: boolean) => css`
  width: 12px;
  height: 12px;
  border-radius: ${theme.radius.sm}px;
  background: ${outline ? theme.color.surface : color};
  border: ${outline ? `1px solid ${theme.color.border}` : 'none'};
`;
